// extracted by mini-css-extract-plugin
export default {"field":"BenefactorTransferModal_field__Lejev","select":"BenefactorTransferModal_select__zihtD","option":"BenefactorTransferModal_option__g6p+l"};